import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import RequirePermission from "../../../auth/RequirePermission";
import { ADMIN_PERMISSIONS } from "../../../auth/adminPermissions";
import AdminPageLayout from "../../../components/midpoint/admin/layout/AdminPageLayout";
import AdminPageHeader from "../../../components/midpoint/admin/layout/AdminPageHeader";
import AdminStatePanel from "../../../components/midpoint/admin/layout/AdminStatePanel";
import AdminTableContainer from "../../../components/midpoint/admin/layout/AdminTableContainer";
import { fetchDealerTrustQueue, fetchSuspiciousListings } from "../../../services/automapTrustSafetyApi";
import { trackTrustSafetyEvent } from "../../../constants/automapTrustSafetyConstants";
import { AdminAutomotiveNav } from "../automotive/AdminAutomotiveNav";
import { TrustSafetyNav } from "./trustSafetyShared";

function ListingsQueue() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    fetchSuspiciousListings()
      .then((d) => { setRows(d.listings || []); trackTrustSafetyEvent("trust_suspicious_listing_queue_viewed"); })
      .finally(() => setLoading(false));
  }, []);
  if (loading) return <AdminStatePanel variant="empty" message="Cargando…" />;
  if (!rows.length) return <AdminStatePanel variant="empty" message="Sin listings sospechosos." />;
  return (
    <AdminTableContainer>
      <table className="admin-table">
        <thead><tr><th>Vehículo</th><th>Dealer</th><th>Reportes</th><th>Casos</th><th>Atípicos</th><th>Dup.</th><th>Acción</th><th></th></tr></thead>
        <tbody>
          {rows.map((row) => (
            <tr key={row.listingId}>
              <td>{row.listing?.title}</td>
              <td>{row.dealerName}</td>
              <td>{row.reportCount}</td>
              <td>{row.openCaseCount}</td>
              <td>{row.outlierFlags}</td>
              <td>{row.duplicateFlags}</td>
              <td>{row.recommendedAction}</td>
              <td><Link to={`/admin/listings/${row.listingId}`}>Ver</Link></td>
            </tr>
          ))}
        </tbody>
      </table>
    </AdminTableContainer>
  );
}

function DealersQueue() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    fetchDealerTrustQueue()
      .then((d) => { setRows(d.dealers || []); trackTrustSafetyEvent("trust_dealer_queue_viewed"); })
      .finally(() => setLoading(false));
  }, []);
  if (loading) return <AdminStatePanel variant="empty" message="Cargando…" />;
  if (!rows.length) return <AdminStatePanel variant="empty" message="Sin dealers con issues." />;
  return (
    <AdminTableContainer>
      <table className="admin-table">
        <thead><tr><th>Dealer</th><th>Ciudad</th><th>Reportes</th><th>Casos</th><th>Obsoletos</th><th>Acción</th><th></th></tr></thead>
        <tbody>
          {rows.map((row) => (
            <tr key={row.dealerId}>
              <td>{row.dealerName}</td>
              <td>{row.city}</td>
              <td>{row.reportCount}</td>
              <td>{row.openCases}</td>
              <td>{row.staleListingCount}</td>
              <td>{row.recommendedAction}</td>
              <td><Link to={`/admin/dealers/${row.dealerId}`}>Ver</Link></td>
            </tr>
          ))}
        </tbody>
      </table>
    </AdminTableContainer>
  );
}

export function AdminTrustSafetyListingsPage() {
  return (
    <RequirePermission permission={ADMIN_PERMISSIONS.REAL_ESTATE_SOURCES_VIEW}>
      <AdminPageLayout>
        <AdminAutomotiveNav active="trust-safety" />
        <AdminPageHeader eyebrow="AutoMapa · Confianza" title="Listings sospechosos" navigation={<TrustSafetyNav active="listings" />} />
        <main className="admin-console__main"><ListingsQueue /></main>
      </AdminPageLayout>
    </RequirePermission>
  );
}

export function AdminTrustSafetyDealersPage() {
  return (
    <RequirePermission permission={ADMIN_PERMISSIONS.REAL_ESTATE_SOURCES_VIEW}>
      <AdminPageLayout>
        <AdminAutomotiveNav active="trust-safety" />
        <AdminPageHeader eyebrow="AutoMapa · Confianza" title="Dealers con issues" navigation={<TrustSafetyNav active="dealers" />} />
        <main className="admin-console__main"><DealersQueue /></main>
      </AdminPageLayout>
    </RequirePermission>
  );
}

export function AdminTrustSafetyRulesPage() {
  const [rules, setRules] = useState(null);
  useEffect(() => { import("../../../services/automapTrustSafetyApi").then((m) => m.fetchTrustSafetyRules().then((d) => setRules(d.rules))); }, []);
  return (
    <RequirePermission permission={ADMIN_PERMISSIONS.REAL_ESTATE_SOURCES_VIEW}>
      <AdminPageLayout>
        <AdminAutomotiveNav active="trust-safety" />
        <AdminPageHeader eyebrow="AutoMapa · Confianza" title="Reglas" navigation={<TrustSafetyNav active="rules" />} />
        <main className="admin-console__main">
          <p className="muted">Solo lectura. Edición persistente: TODO Milestone 21+.</p>
          {rules ? (
            <dl className="admin-detail-dl">
              {Object.entries(rules).filter(([k]) => k !== "editable").map(([k, v]) => (
                <div key={k} style={{ display: "contents" }}><dt>{k}</dt><dd>{typeof v === "object" ? JSON.stringify(v) : String(v)}</dd></div>
              ))}
            </dl>
          ) : <AdminStatePanel variant="empty" message="Cargando reglas…" />}
        </main>
      </AdminPageLayout>
    </RequirePermission>
  );
}
